import React from 'react';
import ReportingBookingCompetitiveVenuesPage from '../components/ReportingBookingCompetitiveVenuesPage';

const axios = require('axios').default;

const ReportingBookingCompetitiveVenuesApp = (props) => {
  if (props.csrfToken) axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrfToken;
  return <ReportingBookingCompetitiveVenuesPage {...props} />;
};

export default ReportingBookingCompetitiveVenuesApp;
